/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSubsidiaryCommandDto
 */
export interface CreateSubsidiaryCommandDto {
    /**
     * Name of the subsidiary
     * @type {string}
     * @memberof CreateSubsidiaryCommandDto
     */
    companyName: string;
    /**
     * SIRET number of the subsidiary
     * @type {string}
     * @memberof CreateSubsidiaryCommandDto
     */
    registrationNumber: string;
    /**
     * Revenue of the last closed fiscal year, in euros
     * @type {number}
     * @memberof CreateSubsidiaryCommandDto
     */
    revenue: number;
    /**
     * Number of employees
     * @type {number}
     * @memberof CreateSubsidiaryCommandDto
     */
    employeesCount: number;
    /**
     * Date calendaire "yyyy-MM-dd". L\'heure est ignorée par le back, aucune conversion de fuseau n\'est appliquée.
     * @type {string}
     * @memberof CreateSubsidiaryCommandDto
     */
    fiscalYearEnd: string;
}

/**
 * Check if a given object implements the CreateSubsidiaryCommandDto interface.
 */
export function instanceOfCreateSubsidiaryCommandDto(value: object): value is CreateSubsidiaryCommandDto {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('employeesCount' in value) || value['employeesCount'] === undefined) return false;
    if (!('fiscalYearEnd' in value) || value['fiscalYearEnd'] === undefined) return false;
    return true;
}

export function CreateSubsidiaryCommandDtoFromJSON(json: any): CreateSubsidiaryCommandDto {
    return CreateSubsidiaryCommandDtoFromJSONTyped(json, false);
}

export function CreateSubsidiaryCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubsidiaryCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'registrationNumber': json['registrationNumber'],
        'revenue': json['revenue'],
        'employeesCount': json['employeesCount'],
        'fiscalYearEnd': json['fiscalYearEnd'],
    };
}

export function CreateSubsidiaryCommandDtoToJSON(json: any): CreateSubsidiaryCommandDto {
    return CreateSubsidiaryCommandDtoToJSONTyped(json, false);
}

export function CreateSubsidiaryCommandDtoToJSONTyped(value?: CreateSubsidiaryCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'registrationNumber': value['registrationNumber'],
        'revenue': value['revenue'],
        'employeesCount': value['employeesCount'],
        'fiscalYearEnd': value['fiscalYearEnd'],
    };
}

